import React from "react";
import { useNavigate } from "react-router";
import "./navigationBar.css";

function navigationBar() {
  return (
    <div className="nav-wide-bar">
      <nav className="nav-nav">
        <NavButton target="/#top-page">Accueil</NavButton>
        <div className="nav-separator" />
        <NavButton target="/tarifs#top-page">Services & Tarifs</NavButton>
        <div className="nav-separator" />
        <NavButton target="/contacts#top-page">Prendre Rendez-Vous</NavButton>
      </nav>
    </div>
  );
}

export default navigationBar;

function NavButton({ children, target }) {
  const navigate = useNavigate();

  return (
    <div className="nav-button" onClick={() => navigate(target)} style={{}}>
      {children}
    </div>
  );
}
